import { register, findAll, find } from '../../../Javascript/Utils.js'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
Swiper.use([Navigation, Pagination])

const componentPrefix = 'mBrandPartnerBar-'

const BrandPartnerBar = el => {
  initSlider(el)
}

const initSlider = (el) => {
  const sliderContainer = find('.swiper-container', el)
  const slides = findAll('.swiper-slide', sliderContainer)
  const prevButton = find(`.${componentPrefix}swiper-button--prev`, sliderContainer)
  const nextButton = find(`.${componentPrefix}swiper-button--next`, sliderContainer)
  const spaceBetween = 30
  let sliderWidth = 0

  slides.forEach((slide) => {
    sliderWidth += slide.offsetWidth + spaceBetween
  })

  const initSlider = (sliderWidth - spaceBetween) > sliderContainer.offsetWidth + 2

  if (initSlider) {
    const BrandPartnerBarSwiper = new Swiper(sliderContainer, {
      slidesPerView: 'auto',
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      }
    })

    BrandPartnerBarSwiper.on('slideChange', function () {
      const activeIndex = BrandPartnerBarSwiper.activeIndex

      if (activeIndex !== 0) {
        prevButton.style.display = 'flex'
      } else {
        prevButton.style.display = 'none'
      }
    })

    BrandPartnerBarSwiper.on('reachEnd', function () {
      if (nextButton) {
        nextButton.style.display = 'none'
      }
    })

    BrandPartnerBarSwiper.on('fromEdge', function () {
      const nextButton = find(`.${componentPrefix}swiper-button--next`, el)
      if (nextButton) {
        nextButton.style.display = 'flex'
      }
    })

    sliderContainer.swiper.slideTo(sliderContainer.swiper.slides.length - 1, 500, false)
  } else {
    if (prevButton) {
      prevButton.remove()
    }
    if (nextButton) {
      nextButton.remove()
    }
  }
}

register('BrandPartnerBar', BrandPartnerBar)
